/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"inline-block w-fit text-xs overflow-hidden bg-primary text-white rounded-md",style:(_vm.tagStyle)},[_vm._v("\n    "+_vm._s(_vm.value)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }